import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    ReferenceInput,
    ReferenceField,
    TextField,
} from 'react-admin';
import { Questions } from '../../custom';
import { EditToolbar } from '../../common/EditToolbar';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import CustomDisableField from './customDisableField';
const QuestionEdit = () => {
    let { programId, testSeriesId, testId, questionId, sectionId } = useParams();
    if (!testId) {
        return <LoadingSection />;
    }
    return (
        <Edit
            title={<SectionTitle />}
            redirect={() => {
                return `test-series/${testSeriesId}/tests/${testId}/sections/${sectionId}/questions`;
            }}
            resource={'section_question_mappings'}
            id={questionId}
        >
            <SimpleForm toolbar={<EditToolbar />}>
                <ReferenceField source="question_id" reference="questions">
                    <CustomDisableField source="name" label="name" />
                </ReferenceField>
                <ReferenceField source="question_id" reference="questions">
                    <CustomDisableField source="content" label="content" />
                </ReferenceField>
                <ReferenceField source="question_id" reference="questions">
                    <CustomDisableField source="image" label="image" />
                </ReferenceField>
                <TextInput source={'display_order'} fullWidth />
                <TextInput source={'positive_marks'} fullWidth />
                <TextInput source={'negative_marks'} fullWidth />
            </SimpleForm>
        </Edit>
    );
};

const SectionTitle = () => {
    const record = useRecordContext<Questions>();
    return record ? <span>{record.id}&quot;</span> : null;
};

export default QuestionEdit;
